import type { SVGProps } from "react";

export const CircleCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}>
    <g fill={props.fill || "#991B1B"} fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
      <path d="M.75 9a8.25 8.25 0 1 1 16.5 0A8.25 8.25 0 0 1 .75 9ZM9 2.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5Z" />
      <path d="M11.78 6.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z" />
      <path d="M6.22 6.22a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={props.fill || "#fff"} d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
